import React, { useState } from 'react';
import { DEFAULT_UNITS } from '../../constants/units';

interface UnitDropdownProps {
  value: string;
  onChange: (unit: string) => void;
  units?: string[];
  placeholder?: string;
  style?: React.CSSProperties;
  className?: string;
}

export const UnitDropdown: React.FC<UnitDropdownProps> = ({
  value,
  onChange,
  units = DEFAULT_UNITS,
  placeholder = 'ĐVT',
  style,
  className = 'input',
}) => {
  const [isCustomMode, setIsCustomMode] = useState(false);

  // Ensure current value is included in list
  const isValueInList = units.includes(value);

  if (isCustomMode) {
    return (
      <input
        type="text"
        className={className}
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        onBlur={() => {
          if (!value) {
            setIsCustomMode(false);
            onChange(units[0] || 'g');
          }
        }}
        autoFocus
        style={{
          textAlign: 'center',
          fontWeight: 700,
          fontSize: 12,
          padding: '4px 2px',
          minHeight: 38,
          height: 38,
          width: '100%',
          boxSizing: 'border-box',
          ...style,
        }}
      />
    );
  }

  return (
    <select
      className={className}
      value={value || ''}
      onChange={(e) => {
        const val = e.target.value;
        if (val === '__CUSTOM__') {
          setIsCustomMode(true);
          onChange('');
        } else {
          onChange(val);
        }
      }}
      style={{
        textAlign: 'center',
        fontWeight: 700,
        fontSize: 12,
        padding: '4px 2px',
        minHeight: 38,
        height: 38,
        width: '100%',
        cursor: 'pointer',
        boxSizing: 'border-box',
        ...style,
      }}
    >
      {!value && <option value="">{placeholder}</option>}
      {value && !isValueInList && <option value={value}>{value}</option>}
      {units.map((u) => (
        <option key={u} value={u}>
          {u}
        </option>
      ))}
      <option value="__CUSTOM__">+ Khác...</option>
    </select>
  );
};
